import type { TextAreaProps } from '@workramp/ui';
import { Button, Stack } from '@workramp/ui';
import { useEffect, useState } from 'react';
import { TextAreaSetting } from '../TextAreaSetting';

interface CustomCSSSettingProps extends TextAreaProps {
  documentationLink?: string;
}

export const CustomCSSSetting = ({ documentationLink, value, onChange, ...props }: CustomCSSSettingProps) => {
  const [textValue, setTextValue] = useState(value);
  const placeholder = `.tile {
    border-radius: 30px
}`;

  useEffect(() => {
    setTextValue(value);
  }, [value]);

  const handleOnChange = (val) => {
    setTextValue(val);
  };

  return (
    <Stack size={2}>
      <TextAreaSetting placeholder={placeholder} value={textValue} onChange={handleOnChange} {...props} />
      {documentationLink && (
        <Button href={documentationLink} target="_blank" trailingIconName="launch:regular" variant="text-inline">
          Documentation
        </Button>
      )}
      <Button isDisabled={textValue === value} onPress={() => onChange(textValue)}>
        Save CSS
      </Button>
    </Stack>
  );
};
